import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from './../../../../environments/environment';

// Service
import { ApiService } from '../../../shared/service/api.service';
import { GlobalService } from '../../../shared/service/global.service';

@Component({
  selector: 'app-sriwijaya',
  templateUrl: './sriwijaya.component.html',
  styles: [
  ]
})
export class SriwijayaComponent implements OnInit {
  
  dataTitle;
  dataSection = [];
  apiAsset = environment.API_ASSETS;
  isLang;
   
  constructor(private apiService: ApiService, 
              private globalService: GlobalService,
              private router: Router) {
     this.globalService.isLoading.next(true);  
  }

  ngOnInit(): void {
    // MultiLanguage
    this.isLang =  this.apiService.isLang();
    
    // Content
    this.apiService.getDataApi('getMenuSection/dxp-sriwijaya').subscribe(response => {
      if(response.success) {
        this.dataTitle = response.data;
        this.dataSection = response.data.section;
        // Meta
        this.globalService.updateMeta(
          response.data.title + ' | Prime Agri Resources',
          response.data.keyword,
          response.data.metadesc
        );
        this.globalService.isLoading.next(false);
      } else {
        this.router.navigate(['/not-found']);
      }
    });
  }

}
